import React, { useEffect } from "react";

import { CSpinner } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";

import { login, tryLogin, externalLogin } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";

const LoginExternal = props => {
  const { logged } = props.general;
  const { token } = useParams();
  const history = useHistory();

  useEffect(() => {
    if (logged) {
      history.push("/");
    }

    let obj = {
      token
    };

    axios
      .post(`${URL.api}integrationLogin`, obj)
      .then(response => {
        if (response.data.success) {
          props.externalLogin(response.data.data);
        }
      })
      .catch(error => {
        toastr.error("Falha", "Não foi possível logar");
        history.push("/");
      });
  }, [history, logged]);

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ width: "100vw", height: "100vh" }}
    >
      <CSpinner size="lg" color="primary" className="mr-3" />
      <h3 className="m-0">Entrando na plataforma...</h3>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      login,
      tryLogin,
      externalLogin
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginExternal);
